import { chain, map } from 'lodash';
import { useMemo } from 'react';
import { GetSearchResultsQuery } from 'src/gqlReactTypings.generated.d';

export const useGetSearchData = (data?: GetSearchResultsQuery) =>
  useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Search experience type
    const dataToUse = (data ?? {
      getSearchResults: { shefResults: [], dishResults: [], cuisineResults: [] },
    }) as GetSearchResultsQuery;
    const [shefResults, dishResults, cuisineResults] = [
      dataToUse?.getSearchResults.shefResults,
      dataToUse?.getSearchResults.dishResults,
      dataToUse?.getSearchResults.cuisineResults,
    ];

    const previewShefResults = shefResults?.slice(0, 3) ?? [];
    const previewDishResults = chain(dishResults).flatMap().slice(0, 3).value() ?? [];
    const previewCuisineResults = cuisineResults?.slice(0, 3) ?? [];

    const shefResultIds = map(shefResults, ({ shef }) => shef?.id);
    const dishResultIds = chain(dishResults)
      .flatMap()
      .map((dish) => dish?.id)
      .value();
    const cuisineResultIds = map(cuisineResults, (cuisine) => cuisine?.category.id);

    const shefResultsHasMore = false;
    const dishResultsHasMore = false;

    return {
      shefResults,
      dishResults,
      cuisineResults,
      previewShefResults,
      previewDishResults,
      previewCuisineResults,
      shefResultIds,
      dishResultIds,
      cuisineResultIds,
      shefResultsHasMore,
      dishResultsHasMore,
    };
  }, [data]);
